import React, { useState, useRef, useEffect } from "react";
import AddButton from "./AddButton";
import { useDispatch, useSelector } from "react-redux";
import { uploadFIles } from "../../../api/admin/filemanagerApi";

const ImageUploader = () => {
  const [images, setImages] = useState([]);
  const inputRef = useRef();
  const dispatch = useDispatch();
  const { showFileUploader } = useSelector((state) => state.file);
  const handleFiles = (files) => {
    const imgArray = [...files].map((file) => ({
      file,
      url: URL.createObjectURL(file),
      isImage: file.type.startsWith("image"),
    }));

    setImages((prev) => [...prev, ...imgArray]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const removeFile = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };
  useEffect(() => {
    if (showFileUploader === false) {
      setImages([]);
    }
  }, [showFileUploader]);

  const handleUpload = () => {
    const formData = new FormData();

    images.forEach((item) => {
      formData.append("files", item.file);
    });
    uploadFIles(formData, dispatch);
  };
  return (
    <div className="w-full mx-auto p-4">
      <div
        className="border-2 border-dashed border-gray-400 rounded-lg p-8 text-center cursor-pointer hover:bg-gray-100"
        onClick={() => inputRef.current.click()}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <input
          type="file"
          multiple
          accept="*/*"
          hidden
          ref={inputRef}
          onChange={(e) => handleFiles(e.target.files)}
        />

        <p className="text-gray-600 text-lg">
          <strong>Drag & Drop</strong> your images/files here <br />
          or <span className="text-blue-600 underline">click to upload</span>
        </p>
      </div>

      <div className="flex justify-start items-center gap-3 flex-wrap mt-5">
        {images.map((img, i) => (
          <div key={i} className="relative">
            {img.isImage ? (
              <img
                src={img.url}
                alt="uploaded"
                className="w-10 h-10 object-cover rounded-md border"
              />
            ) : (
              <div className="w-10 h-10 flex items-center justify-center text-xs bg-gray-200 border rounded-md p-1">
                {img.file.type.split("/")[1]?.toUpperCase() || "FILE"}
              </div>
            )}

            <button
              onClick={() => removeFile(i)}
              className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center"
            >
              ×
            </button>
          </div>
        ))}

        {images.length > 0 && (
          <div>
            <AddButton onClick={handleUpload} text="Upload Now" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
